/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { UiVariablesPb } from "../../../../gen/skills/ui_variables";
import { TriggerArgs_TimerCallback } from "../../trigger_args";

export const protobufPackage = "complimentary_actions";

export interface SpoofPhoneInputsActionArgs {
  trigger:
    | TriggerArgs_TimerCallback
    | undefined;
  /** [s] */
  durationS: number;
  phoneUiVariables: UiVariablesPb | undefined;
}

function createBaseSpoofPhoneInputsActionArgs(): SpoofPhoneInputsActionArgs {
  return { trigger: undefined, durationS: 0, phoneUiVariables: undefined };
}

export const SpoofPhoneInputsActionArgs = {
  encode(message: SpoofPhoneInputsActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.trigger !== undefined) {
      TriggerArgs_TimerCallback.encode(message.trigger, writer.uint32(10).fork()).ldelim();
    }
    if (message.durationS !== 0) {
      writer.uint32(21).float(message.durationS);
    }
    if (message.phoneUiVariables !== undefined) {
      UiVariablesPb.encode(message.phoneUiVariables, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofPhoneInputsActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofPhoneInputsActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.trigger = TriggerArgs_TimerCallback.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.durationS = reader.float();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.phoneUiVariables = UiVariablesPb.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpoofPhoneInputsActionArgs {
    return {
      trigger: isSet(object.trigger) ? TriggerArgs_TimerCallback.fromJSON(object.trigger) : undefined,
      durationS: isSet(object.durationS) ? globalThis.Number(object.durationS) : 0,
      phoneUiVariables: isSet(object.phoneUiVariables) ? UiVariablesPb.fromJSON(object.phoneUiVariables) : undefined,
    };
  },

  toJSON(message: SpoofPhoneInputsActionArgs): unknown {
    const obj: any = {};
    if (message.trigger !== undefined) {
      obj.trigger = TriggerArgs_TimerCallback.toJSON(message.trigger);
    }
    if (message.durationS !== 0) {
      obj.durationS = message.durationS;
    }
    if (message.phoneUiVariables !== undefined) {
      obj.phoneUiVariables = UiVariablesPb.toJSON(message.phoneUiVariables);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofPhoneInputsActionArgs>, I>>(base?: I): SpoofPhoneInputsActionArgs {
    return SpoofPhoneInputsActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofPhoneInputsActionArgs>, I>>(object: I): SpoofPhoneInputsActionArgs {
    const message = createBaseSpoofPhoneInputsActionArgs();
    message.trigger = (object.trigger !== undefined && object.trigger !== null)
      ? TriggerArgs_TimerCallback.fromPartial(object.trigger)
      : undefined;
    message.durationS = object.durationS ?? 0;
    message.phoneUiVariables = (object.phoneUiVariables !== undefined && object.phoneUiVariables !== null)
      ? UiVariablesPb.fromPartial(object.phoneUiVariables)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
